module.exports = {"rE":"1.666.0"}